import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightning01 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.1667 2.33333L4.7757 14.8025C4.36876 15.2908 4.16529 15.535 4.16218 15.7412C4.15947 15.9205 4.23935 16.091 4.3788 16.2037C4.53921 16.3333 4.85704 16.3333 5.49271 16.3333H14L12.8333 25.6667L23.2243 13.1975C23.6312 12.7092 23.8347 12.465 23.8378 12.2588C23.8405 12.0795 23.7606 11.909 23.6212 11.7963C23.4608 11.6667 23.143 11.6667 22.5073 11.6667H14L15.1667 2.33333Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLightning01;
